import { SystemFuncArgs } from '@brochington/ecstatic';
import Canvas from 'editor/components/Canvas';
import CarnivoreCtx from 'editor/components/CarnivoreCtx';
import CarnivoreDoc from 'editor/components/CarnivoreDoc';
import CarnivoreSheet from 'editor/components/CarnivoreSheet';
import { Components } from '../components';

export const manageSheetComponents = [
  CarnivoreCtx,
  CarnivoreDoc,
  CarnivoreSheet,
  Canvas,
];

// TODO: This is probably going away!
export function manageSheet(args: SystemFuncArgs<Components>): void {
  const { entity, components } = args;
  const { ctx: carnCtx } = components.get(CarnivoreCtx);
  const { doc } = components.get(CarnivoreDoc);
  const sheetComp = components.get(CarnivoreSheet);
  const { canvas } = components.get(Canvas);

  if (entity.state === 'creating') {
    const ctx = canvas.getContext('2d');

    if (ctx) {
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(canvas, 0, 0);
    }

    const sheet = carnCtx.createSheet({
      id: 'sheet-1',
      width: canvas.width,
      height: canvas.height,
    });

    sheetComp.sheet = sheet;

    doc.addSheet(sheet.id);
  }
}
